import type { ComparisonConfig } from './ComparisonPage';

const HOTELOGIX_TH: ComparisonConfig = {
  slug: 'hotelstack-vs-hotelogix',
  competitorName: 'Hotelogix',
  heroTitle: 'HotelStack.io เทียบกับ Hotelogix',
  heroSubtitle: 'การเปรียบเทียบอย่างครอบคลุมระหว่างสองแพลตฟอร์มจัดการโรงแรมชั้นนำ ดูว่า HotelStack.io มอบฟีเจอร์มากกว่า สถาปัตยกรรมทันสมัย และคุ้มค่ากว่า Hotelogix อย่างไร',
  overviewComparison: [
    { label: 'โมดูลทั้งหมด', hotelstack: '36 โมดูลแบบบูรณาการ', competitor: '15 โมดูล' },
    { label: 'สถาปัตยกรรม', hotelstack: 'SaaS คลาวด์เนทีฟ', competitor: 'คลาวด์รุ่นเก่า' },
    { label: 'การเข้าถึงทั่วโลก', hotelstack: 'กว่า 40 ประเทศ', competitor: 'เอเชียเป็นหลัก' },
    { label: 'ตัวจัดการช่องทาง', hotelstack: 'ในตัว (กว่า 100 OTA)', competitor: 'ต้องซื้อส่วนเสริม' },
    { label: 'ระบบจองห้อง', hotelstack: 'BookMyRoom.io (ฟรี)', competitor: 'วิดเจ็ตพื้นฐาน' },
    { label: 'การสนับสนุน', hotelstack: 'ทีมเฉพาะ 24/7', competitor: 'อีเมล + แชท' },
  ],
  featureTable: [
    {
      category: 'ระบบจัดการโรงแรมหลัก',
      features: [
        { name: 'บอร์ดห้องพักแบบภาพ', hotelstack: true, competitor: true },
        { name: 'เช็คอินแบบลากและวาง', hotelstack: true, competitor: false },
        { name: 'วิซาร์ดตรวจสอบกลางคืน', hotelstack: true, competitor: true },
        { name: 'การจัดการโฟลิโอแขก', hotelstack: true, competitor: true },
        { name: 'พอร์ทัลเช็คอินออนไลน์', hotelstack: true, competitor: false },
        { name: 'หน้าต่างจองแขกวอล์คอิน', hotelstack: true, competitor: 'จำกัด' },
      ],
    },
    {
      category: 'การจัดการรายได้',
      features: [
        { name: 'กฎการกำหนดราคาแบบไดนามิก', hotelstack: true, competitor: false },
        { name: 'ตัวจำลองรายได้แบบ What-If', hotelstack: true, competitor: false },
        { name: 'ตัวตรวจสอบราคาคู่แข่ง', hotelstack: true, competitor: false },
        { name: 'การพยากรณ์อุปสงค์', hotelstack: true, competitor: false },
        { name: 'การวิเคราะห์ RevPAR', hotelstack: true, competitor: 'พื้นฐาน' },
      ],
    },
    {
      category: 'การจัดการแขก',
      features: [
        { name: 'โปรไฟล์แขก 360 องศา', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'การจัดการโปรแกรมสะสมคะแนน', hotelstack: true, competitor: false },
        { name: 'ระบบอัตโนมัติสื่อสารกับแขก', hotelstack: true, competitor: 'จำกัด' },
        { name: 'การวิเคราะห์การใช้จ่ายของแขก', hotelstack: true, competitor: false },
        { name: 'อัปโหลดบัตรประชาชนและถ่ายรูป', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'อาหารและเครื่องดื่ม & POS',
      features: [
        { name: 'เทอร์มินัล POS', hotelstack: true, competitor: false },
        { name: 'แผนผังโต๊ะอาหาร', hotelstack: true, competitor: false },
        { name: 'ระบบแสดงผลครัว', hotelstack: true, competitor: false },
        { name: 'โมดูลบริการห้องพัก', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'รายงานและการวิเคราะห์',
      features: [
        { name: 'รายงานด่วน', hotelstack: true, competitor: true },
        { name: 'งบกำไรขาดทุน', hotelstack: true, competitor: false },
        { name: 'รายงานอัตราการจอง', hotelstack: true, competitor: false },
        { name: 'รายงานการปฏิบัติตามกฎหมายภาษี', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'ตัวสร้างรายงานแบบกำหนดเอง', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'การจัดการหลายสาขา',
      features: [
        { name: 'แดชบอร์ดเครือข่าย', hotelstack: true, competitor: true },
        { name: 'การวิเคราะห์ข้ามสาขา', hotelstack: true, competitor: false },
        { name: 'การจัดการราคาส่วนกลาง', hotelstack: true, competitor: false },
        { name: 'การตั้งค่าแบรนด์', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ความยืดหยุ่นและออฟไลน์',
      features: [
        { name: 'PWA ที่ใช้งานออฟไลน์ได้', hotelstack: true, competitor: false },
        { name: 'คิวการเปลี่ยนแปลงแบบออฟไลน์', hotelstack: true, competitor: false },
        { name: 'ซิงค์เบื้องหลังเมื่อเชื่อมต่อใหม่', hotelstack: true, competitor: false },
        { name: 'การกระทบยอดที่ตรวจจับความขัดแย้ง', hotelstack: true, competitor: false },
        { name: 'ฟรอนต์เดสก์ที่ติดตั้งได้', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ฝ่ายขายองค์กรและกรุ๊ป',
      features: [
        { name: 'การจัดการราคาองค์กร', hotelstack: true, competitor: false },
        { name: 'การจองแบบกรุ๊ปพร้อมรายชื่อห้องพัก', hotelstack: true, competitor: 'ส่วนเสริม' },
        { name: 'รายงานอายุลูกหนี้และผลผลิต', hotelstack: true, competitor: false },
        { name: 'การจองร้านอาหาร', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'พนักงานและทรัพยากรบุคคล',
      features: [
        { name: 'ทำเนียบพนักงานและการจัดตารางเวร', hotelstack: true, competitor: false },
        { name: 'การประมวลผลเงินเดือน', hotelstack: true, competitor: false },
        { name: 'การลาและการลงเวลา', hotelstack: true, competitor: false },
        { name: 'การวิเคราะห์ผลการปฏิบัติงาน', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$60+',
    hotelstackNote: 'รวมทั้ง 36 โมดูล ไม่จำกัดฟีเจอร์ เริ่มต้นใช้งานฟรีและย้ายข้อมูลฟรี ราคาตามภูมิภาคเป็น EUR, GBP, AED, INR, THB',
    competitorNote: 'แผนพื้นฐานพร้อมโมดูลจำกัด ตัวจัดการช่องทางและฟีเจอร์ขั้นสูงมีค่าใช้จ่ายเพิ่มเติม',
  },
  advantages: [
    'โมดูลมากกว่าเท่าตัว (36 เทียบกับ 15) โดยไม่มีค่าธรรมเนียมเพิ่มเติมสำหรับฟีเจอร์หลัก',
    'สถาปัตยกรรมคลาวด์เนทีฟทันสมัยสร้างในปี 2024 พร้อมซิงค์แบบเรียลไทม์บนทุกอุปกรณ์',
    'รองรับหลายสกุลเงินพร้อมราคาตามภูมิภาคใน 6 สกุลเงิน และเครื่องมือปฏิบัติตามกฎหมายสำหรับกว่า 40 ประเทศ',
    'ระบบจองในตัวผ่าน BookMyRoom.io — การจองตรงไม่มีค่าคอมมิชชั่น',
    'การจัดการรายได้ขั้นสูงพร้อมราคาไดนามิก การพยากรณ์อุปสงค์ และตัวจำลอง What-If',
    'โมดูลอาหารและเครื่องดื่มและ POS สมบูรณ์พร้อมจัดการโต๊ะ แสดงผลครัว และบริการห้องพัก',
    'ราคาเริ่มต้นต่ำกว่าพร้อมฟีเจอร์มากกว่าในแผนพื้นฐาน',
    'ย้ายข้อมูลฟรีจาก Hotelogix พร้อมทีมสนับสนุนเริ่มต้นใช้งานเฉพาะ',
  ],
  verdict: {
    title: 'คำตัดสินของเรา',
    summary: 'HotelStack.io เป็นทางเลือกที่แข็งแกร่งกว่าสำหรับโรงแรมที่ต้องการแพลตฟอร์มครบวงจรทันสมัย ด้วย 36 โมดูล การจัดการรายได้ในตัว ความสามารถด้านอาหารและเครื่องดื่ม และราคาต่ำกว่า มอบคุณค่ามากกว่า Hotelogix อย่างมาก Hotelogix อาจเหมาะกับโรงแรมงบจำกัดที่ต้องการเฉพาะฟังก์ชัน PMS พื้นฐาน',
    bestFor: [
      'โรงแรมที่ต้องการแพลตฟอร์มครบวงจรทันสมัยไม่มีค่าธรรมเนียมเพิ่มเติม',
      'สถานที่ที่ต้องการจัดการรายได้ขั้นสูงและราคาไดนามิก',
      'โรงแรมที่ต้องการอาหารและเครื่องดื่ม POS และบริการห้องพัก',
      'สถานที่ที่ต้องการปฏิบัติตามกฎหมายท้องถิ่นและการออกบิลหลายสกุลเงิน',
      'เครือโรงแรมหลายสาขาที่ต้องการการวิเคราะห์ส่วนกลางและจัดการราคาแบบรวม',
    ],
  },
  faqItems: [
    { question: 'ฉันสามารถย้ายจาก Hotelogix มาที่ HotelStack.io ได้หรือไม่?', answer: 'ได้ ทีมของเราดำเนินการย้ายข้อมูลทั้งหมดจาก Hotelogix รวมถึงโปรไฟล์แขก ประวัติการจอง แผนราคา และการตั้งค่าห้องพัก การย้ายข้อมูลฟรีและมักจะเสร็จภายใน 48 ชั่วโมงโดยไม่มีการหยุดชะงัก' },
    { question: 'HotelStack.io มีฟีเจอร์ทั้งหมดที่ Hotelogix มีหรือไม่?', answer: 'HotelStack.io รวมทุกฟีเจอร์ที่ Hotelogix มีบวกเพิ่มอีก 17 โมดูล รวมถึงการจัดการรายได้ อาหารและเครื่องดื่ม/POS โปรแกรมสะสมคะแนน เครื่องมือปฏิบัติตามกฎหมาย และการวิเคราะห์ขั้นสูงที่ Hotelogix ไม่มี' },
    { question: 'ราคาของ HotelStack.io เปรียบเทียบกับ Hotelogix อย่างไร?', answer: 'HotelStack.io เริ่มต้นที่ $49/เดือน พร้อมรวมทั้ง 36 โมดูล ราคาตามภูมิภาคเป็น EUR, GBP, AED, INR และ THB Hotelogix เริ่มต้นที่ประมาณ $60+/เดือนสำหรับแผนพื้นฐาน โดยมีค่าใช้จ่ายเพิ่มสำหรับตัวจัดการช่องทางและฟีเจอร์อื่นๆ' },
    { question: 'HotelStack.io เหมาะกับโรงแรมขนาดเล็กที่ใช้ Hotelogix อยู่หรือไม่?', answer: 'แน่นอน แผน Starter ของเราออกแบบมาสำหรับสถานที่สูงสุด 50 ห้องพร้อมเปิดฟีเจอร์ทั้งหมด โรงแรมขนาดเล็กจำนวนมากเปลี่ยนมาจาก Hotelogix เพื่อโมดูลเพิ่มเติมและราคาที่ต่ำกว่า' },
  ],
};

const CLOUDBEDS_TH: ComparisonConfig = {
  slug: 'hotelstack-vs-cloudbeds',
  competitorName: 'Cloudbeds',
  heroTitle: 'HotelStack.io เทียบกับ Cloudbeds',
  heroSubtitle: 'ทั้งสองเป็นแพลตฟอร์มคลาวด์เนทีฟ HotelStack.io มอบโมดูลมากกว่า ราคาต่ำกว่า และความสามารถด้านอาหารและเครื่องดื่ม/POS เต็มรูปแบบที่ Cloudbeds ไม่มี — ทั้งหมดพร้อมราคาตามภูมิภาคหลายสกุลเงิน',
  overviewComparison: [
    { label: 'โมดูลทั้งหมด', hotelstack: '36 โมดูล', competitor: 'กว่า 20 โมดูล' },
    { label: 'ราคา', hotelstack: 'เริ่มต้น $49/เดือน', competitor: 'เริ่มต้น $100+/เดือน' },
    { label: 'ราคาตามภูมิภาค', hotelstack: '6 สกุลเงิน', competitor: 'USD เท่านั้น' },
    { label: 'อาหารและเครื่องดื่ม / POS', hotelstack: 'ในตัว', competitor: 'ไม่มี' },
    { label: 'ระบบจองห้อง', hotelstack: 'BookMyRoom.io (ฟรี)', competitor: 'วิดเจ็ตพื้นฐาน' },
    { label: 'การเริ่มต้นใช้งาน', hotelstack: 'ฟรี + ทีมเฉพาะ', competitor: 'บริการตนเอง' },
  ],
  featureTable: [
    {
      category: 'ระบบจัดการโรงแรมหลัก',
      features: [
        { name: 'บอร์ดห้องพักแบบภาพ', hotelstack: true, competitor: true },
        { name: 'การจัดการการจอง', hotelstack: true, competitor: true },
        { name: 'การจองแบบกลุ่ม', hotelstack: true, competitor: true },
        { name: 'วิซาร์ดตรวจสอบกลางคืน', hotelstack: true, competitor: true },
        { name: 'พอร์ทัลเช็คอินออนไลน์', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'การปฏิบัติตามกฎหมายท้องถิ่น',
      features: [
        { name: 'การออกบิลหลายสกุลเงิน', hotelstack: true, competitor: 'จำกัด' },
        { name: 'ระบบอัตโนมัติภาษีท้องถิ่น', hotelstack: true, competitor: false },
        { name: 'การปฏิบัติตามการลงทะเบียนแขก', hotelstack: true, competitor: false },
        { name: 'การคุ้มครองข้อมูล GDPR', hotelstack: true, competitor: true },
        { name: 'ช่องทางชำระเงินท้องถิ่น', hotelstack: true, competitor: 'จำกัด' },
        { name: 'ใบแจ้งหนี้ท้องถิ่น', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'การจัดการรายได้',
      features: [
        { name: 'การกำหนดราคาไดนามิก', hotelstack: true, competitor: true },
        { name: 'การวิเคราะห์รายได้', hotelstack: true, competitor: true },
        { name: 'ตัวตรวจสอบราคาคู่แข่ง', hotelstack: true, competitor: 'ส่วนเสริม' },
        { name: 'ตัวจำลอง What-If', hotelstack: true, competitor: false },
        { name: 'การพยากรณ์อุปสงค์', hotelstack: true, competitor: 'พื้นฐาน' },
      ],
    },
    {
      category: 'อาหารและเครื่องดื่ม & การดำเนินงาน',
      features: [
        { name: 'เทอร์มินัล POS', hotelstack: true, competitor: false },
        { name: 'โมดูลบริการห้องพัก', hotelstack: true, competitor: false },
        { name: 'บอร์ดแม่บ้าน', hotelstack: true, competitor: true },
        { name: 'ใบสั่งงานซ่อมบำรุง', hotelstack: true, competitor: false },
        { name: 'การจัดตารางพนักงาน', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'การปฏิบัติตามกฎหมาย & รายงาน',
      features: [
        { name: 'รายงานภาษีท้องถิ่น', hotelstack: true, competitor: false },
        { name: 'บันทึกการตรวจสอบ', hotelstack: true, competitor: true },
        { name: 'งบกำไรขาดทุน', hotelstack: true, competitor: 'จำกัด' },
        { name: 'ตัวสร้างรายงานแบบกำหนดเอง', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'ความยืดหยุ่นและออฟไลน์',
      features: [
        { name: 'PWA ที่ใช้งานออฟไลน์ได้', hotelstack: true, competitor: false },
        { name: 'คิวการเปลี่ยนแปลงแบบออฟไลน์', hotelstack: true, competitor: false },
        { name: 'ซิงค์เบื้องหลังเมื่อเชื่อมต่อใหม่', hotelstack: true, competitor: false },
        { name: 'การกระทบยอดที่ตรวจจับความขัดแย้ง', hotelstack: true, competitor: false },
        { name: 'ฟรอนต์เดสก์ที่ติดตั้งได้', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ฝ่ายขายองค์กรและกรุ๊ป',
      features: [
        { name: 'การจัดการราคาองค์กร', hotelstack: true, competitor: false },
        { name: 'การจองแบบกรุ๊ปพร้อมรายชื่อห้องพัก', hotelstack: true, competitor: 'จำกัด' },
        { name: 'รายงานอายุลูกหนี้และผลผลิต', hotelstack: true, competitor: false },
        { name: 'การจองร้านอาหาร', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'พนักงานและทรัพยากรบุคคล',
      features: [
        { name: 'ทำเนียบพนักงานและการจัดตารางเวร', hotelstack: true, competitor: 'ส่วนเสริม' },
        { name: 'การประมวลผลเงินเดือน', hotelstack: true, competitor: false },
        { name: 'การลาและการลงเวลา', hotelstack: true, competitor: false },
        { name: 'การวิเคราะห์ผลการปฏิบัติงาน', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: 'รวมทั้ง 36 โมดูล ราคาตามภูมิภาคเป็น EUR, GBP, AED, INR, THB เริ่มต้นใช้งานและย้ายข้อมูลฟรี',
    competitorNote: 'ราคาเป็น USD เท่านั้น ($100+/เดือน) มีค่าใช้จ่ายเพิ่มสำหรับฟีเจอร์พรีเมียมและการเชื่อมต่อ',
  },
  advantages: [
    'รวมทั้ง 36 โมดูลในราคาประมาณครึ่งหนึ่ง — ไม่มีค่าธรรมเนียมเพิ่มสำหรับฟีเจอร์หลัก',
    'ราคาตามภูมิภาคใน 6 สกุลเงิน — ไม่มีความเสี่ยงจากอัตราแลกเปลี่ยนสำหรับสถานที่ระหว่างประเทศ',
    'โมดูลอาหารและเครื่องดื่มสมบูรณ์พร้อมเทอร์มินัล POS บริการห้องพัก และจัดการครัว',
    'เครื่องมือปฏิบัติตามกฎหมายท้องถิ่นสำหรับระบบอัตโนมัติภาษี การลงทะเบียนแขก และ GDPR',
    'รองรับช่องทางชำระเงินหลายช่องทางผ่าน PaymentHooks.com (Stripe, PayPal, กว่า 50 ช่องทาง) สำหรับวิธีการชำระเงินทั่วโลกและท้องถิ่น',
    'โมดูลจัดการพนักงานพร้อมเงินเดือน การเข้างาน และจัดตารางกะ',
    'การจัดการซ่อมบำรุงและใบสั่งงานพร้อมติดตามทรัพย์สิน',
    'เริ่มต้นใช้งานฟรีและย้ายข้อมูลพร้อมทีมสนับสนุนเฉพาะ',
  ],
  verdict: {
    title: 'คำตัดสินของเรา',
    summary: 'HotelStack.io มอบโมดูลมากกว่า คุ้มค่ากว่า และเครื่องมือการดำเนินงานครบถ้วนในราคาประมาณครึ่งหนึ่งของ Cloudbeds แม้ Cloudbeds จะเป็นแพลตฟอร์มที่ดีสำหรับ PMS พื้นฐานและจัดการช่องทาง HotelStack.io เพิ่มอาหารและเครื่องดื่ม/POS จัดการพนักงาน ซ่อมบำรุง และเครื่องมือรายได้ขั้นสูง — ทั้งหมดรวมในราคาพื้นฐาน',
    bestFor: [
      'โรงแรมที่ต้องการแพลตฟอร์มครบวงจรในราคาที่ต่ำกว่า',
      'สถานที่ที่ต้องการอาหารและเครื่องดื่ม POS และจัดการพนักงานในระบบเดียว',
      'โรงแรมที่ต้องการปฏิบัติตามกฎหมายท้องถิ่นและออกบิลหลายสกุลเงิน',
      'สถานที่ที่ต้องการการเริ่มต้นใช้งานแบบเฉพาะแทนการตั้งค่าด้วยตนเอง',
      'เครือโรงแรมหลายสาขาที่ต้องการการวิเคราะห์ส่วนกลางและจัดการราคาแบบรวม',
    ],
  },
  faqItems: [
    { question: 'ฉันสามารถย้ายจาก Cloudbeds มาที่ HotelStack.io ได้หรือไม่?', answer: 'ได้ ทีมเริ่มต้นใช้งานของเราดำเนินการย้ายข้อมูลทั้งหมดจาก Cloudbeds รวมถึงโปรไฟล์แขก ประวัติการจอง และแผนราคา การย้ายข้อมูลฟรีและมักจะเสร็จภายใน 48 ชั่วโมง' },
    { question: 'HotelStack.io รองรับช่องทาง OTA เดียวกับ Cloudbeds หรือไม่?', answer: 'ใช่ HotelStack.io เชื่อมต่อกับกว่า 100 OTA รวมถึง Booking.com, Expedia, Airbnb, Agoda และแพลตฟอร์มท้องถิ่น รองรับการเชื่อมต่อ GDS ผ่าน Amadeus และ Sabre ด้วย' },
    { question: 'ทำไม HotelStack.io จึงราคาถูกกว่า Cloudbeds?', answer: 'HotelStack.io รวมทั้ง 36 โมดูลในทุกแผนโดยไม่มีค่าธรรมเนียมเพิ่ม ราคาตามภูมิภาคใน 6 สกุลเงินช่วยลดต้นทุนเพิ่มเติม Cloudbeds คิดค่าธรรมเนียมเพิ่มสำหรับฟีเจอร์พรีเมียมและเสนอราคาเป็น USD เท่านั้น' },
    { question: 'HotelStack.io ใช้ได้กับสถานที่ระหว่างประเทศหรือไม่?', answer: 'แน่นอน HotelStack.io รองรับการออกบิลหลายสกุลเงิน การปฏิบัติตามกฎหมายภาษีท้องถิ่น และช่องทางชำระเงินระหว่างประเทศ โรงแรมในกว่า 40 ประเทศใช้ HotelStack.io จัดการการดำเนินงาน' },
  ],
};

const MEWS_TH: ComparisonConfig = {
  slug: 'hotelstack-vs-mews',
  competitorName: 'Mews',
  heroTitle: 'HotelStack.io เทียบกับ Mews',
  heroSubtitle: 'Mews มุ่งเป้าโรงแรมระดับองค์กรด้วยราคาพรีเมียมและค่าใช้จ่ายในการติดตั้ง HotelStack.io มอบประสบการณ์ทันสมัยเทียบเท่าพร้อมโมดูลมากกว่าในราคาเพียงเศษเสี้ยว — เริ่มต้นใช้งานฟรี',
  overviewComparison: [
    { label: 'กลุ่มโรงแรม', hotelstack: 'SMB ถึงองค์กร', competitor: 'องค์กรเท่านั้น' },
    { label: 'ราคา', hotelstack: 'เริ่มต้น $49/เดือน', competitor: '$200+/เดือน' },
    { label: 'โมดูลทั้งหมด', hotelstack: '36 ในตัว', competitor: 'กว่า 15 หลัก' },
    { label: 'อาหารและเครื่องดื่ม / POS', hotelstack: 'ในตัว', competitor: 'ผ่านการเชื่อมต่อ' },
    { label: 'คุณภาพ UI/UX', hotelstack: 'ดีไซน์หรูหราสีเข้มทันสมัย', competitor: 'ดีไซน์มินิมอลทันสมัย' },
    { label: 'การเริ่มต้นใช้งาน', hotelstack: 'ฟรี + ทีมเฉพาะ', competitor: 'ติดตั้งแบบเสียค่าใช้จ่าย' },
  ],
  featureTable: [
    {
      category: 'ระบบจัดการโรงแรมหลัก',
      features: [
        { name: 'สถาปัตยกรรมคลาวด์เนทีฟ', hotelstack: true, competitor: true },
        { name: 'UI/UX ทันสมัย', hotelstack: true, competitor: true },
        { name: 'ซิงค์แบบเรียลไทม์', hotelstack: true, competitor: true },
        { name: 'เข้าถึงได้หลายอุปกรณ์', hotelstack: true, competitor: true },
        { name: 'ระบบอัตโนมัติตรวจสอบกลางคืน', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'การปฏิบัติตามกฎหมายท้องถิ่น',
      features: [
        { name: 'การออกบิลหลายสกุลเงิน', hotelstack: true, competitor: true },
        { name: 'ระบบอัตโนมัติภาษีท้องถิ่น', hotelstack: true, competitor: 'EU เท่านั้น' },
        { name: 'การปฏิบัติตามการลงทะเบียนแขก', hotelstack: true, competitor: 'EU เท่านั้น' },
        { name: 'การคุ้มครองข้อมูล GDPR', hotelstack: true, competitor: true },
        { name: 'ช่องทางชำระเงินท้องถิ่น', hotelstack: true, competitor: 'จำกัด' },
        { name: 'ราคาตามภูมิภาค (6 สกุลเงิน)', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'รายได้และการจัดจำหน่าย',
      features: [
        { name: 'ตัวจัดการช่องทาง', hotelstack: true, competitor: true },
        { name: 'การกำหนดราคาไดนามิก', hotelstack: true, competitor: true },
        { name: 'ระบบจองห้อง', hotelstack: true, competitor: true },
        { name: 'การวิเคราะห์รายได้', hotelstack: true, competitor: true },
        { name: 'ตัวจำลอง What-If', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'การดำเนินงาน',
      features: [
        { name: 'การจัดการแม่บ้าน', hotelstack: true, competitor: true },
        { name: 'โมดูล POS / อาหารและเครื่องดื่ม', hotelstack: true, competitor: 'ผ่านการเชื่อมต่อ' },
        { name: 'การจัดตารางพนักงาน', hotelstack: true, competitor: false },
        { name: 'ซ่อมบำรุง / ใบสั่งงาน', hotelstack: true, competitor: false },
        { name: 'การสื่อสารกับแขก', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'ราคาและการสนับสนุน',
      features: [
        { name: 'เริ่มต้นใช้งานฟรี', hotelstack: true, competitor: false },
        { name: 'ย้ายข้อมูลฟรี', hotelstack: true, competitor: false },
        { name: 'สนับสนุน 24/7', hotelstack: true, competitor: 'เวลาทำการ' },
        { name: 'ไม่มีค่าธรรมเนียมติดตั้ง', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ความยืดหยุ่นและออฟไลน์',
      features: [
        { name: 'PWA ที่ใช้งานออฟไลน์ได้', hotelstack: true, competitor: false },
        { name: 'คิวการเปลี่ยนแปลงแบบออฟไลน์', hotelstack: true, competitor: false },
        { name: 'ซิงค์เบื้องหลังเมื่อเชื่อมต่อใหม่', hotelstack: true, competitor: false },
        { name: 'การกระทบยอดที่ตรวจจับความขัดแย้ง', hotelstack: true, competitor: false },
        { name: 'ฟรอนต์เดสก์ที่ติดตั้งได้', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ฝ่ายขายองค์กรและกรุ๊ป',
      features: [
        { name: 'การจัดการราคาองค์กร', hotelstack: true, competitor: 'ส่วนเสริม' },
        { name: 'การจองแบบกรุ๊ปพร้อมรายชื่อห้องพัก', hotelstack: true, competitor: true },
        { name: 'รายงานอายุลูกหนี้และผลผลิต', hotelstack: true, competitor: 'ส่วนเสริม' },
        { name: 'การจองร้านอาหาร', hotelstack: true, competitor: 'ผ่านการเชื่อมต่อ' },
      ],
    },
    {
      category: 'พนักงานและทรัพยากรบุคคล',
      features: [
        { name: 'ทำเนียบพนักงานและการจัดตารางเวร', hotelstack: true, competitor: 'ผ่านการเชื่อมต่อ' },
        { name: 'การประมวลผลเงินเดือน', hotelstack: true, competitor: false },
        { name: 'การลาและการลงเวลา', hotelstack: true, competitor: false },
        { name: 'การวิเคราะห์ผลการปฏิบัติงาน', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$200+',
    hotelstackNote: 'รวมทั้ง 36 โมดูล เริ่มต้นใช้งานและย้ายข้อมูลฟรี ราคาตามภูมิภาคใน 6 สกุลเงิน',
    competitorNote: 'ราคาระดับองค์กร ($200+/เดือน) ค่าติดตั้งและเริ่มต้นใช้งานแบบเสียเงิน การสนับสนุนพรีเมียมมีค่าใช้จ่ายเพิ่ม',
  },
  advantages: [
    'ราคาเริ่มต้นต่ำกว่าประมาณ 75% พร้อมโมดูลมากกว่าในทุกแผน',
    'เริ่มต้นใช้งานฟรีและย้ายข้อมูลเทียบกับค่าติดตั้งของ Mews',
    'อาหารและเครื่องดื่มและ POS ในตัวสมบูรณ์เทียบกับต้องเชื่อมต่อบุคคลที่สามกับ Mews',
    'ราคาตามภูมิภาคใน 6 สกุลเงิน — โรงแรมจ่ายด้วยสกุลเงินท้องถิ่น',
    'การจัดการพนักงาน เงินเดือน และจัดตารางกะรวมอยู่ในตัว',
    'การจัดการซ่อมบำรุงและใบสั่งงานในตัวบนแพลตฟอร์ม',
    'สนับสนุนเฉพาะ 24/7 เทียบกับสนับสนุนเวลาทำการของ Mews',
    'เข้าถึงได้สำหรับโรงแรม SMB ไม่ใช่แค่องค์กร — ทุกแผนรวมทุกโมดูล',
  ],
  verdict: {
    title: 'คำตัดสินของเรา',
    summary: 'Mews เป็นแพลตฟอร์มที่ยอดเยี่ยมสำหรับโรงแรมองค์กรที่พร้อมจ่ายราคาพรีเมียม HotelStack.io เทียบเท่า Mews ในด้าน UX ทันสมัยและสถาปัตยกรรมคลาวด์ พร้อมเพิ่มอาหารและเครื่องดื่ม/POS จัดการพนักงาน และโมดูลซ่อมบำรุง — ทั้งหมดในราคาประมาณหนึ่งในสี่พร้อมเริ่มต้นใช้งานฟรี',
    bestFor: [
      'โรงแรมที่ต้องการ UX คุณภาพเทียบเท่า Mews ในราคาที่เข้าถึงได้มากกว่า',
      'สถานที่ที่ต้องการอาหารและเครื่องดื่ม POS และเครื่องมือดำเนินงานในตัว',
      'โรงแรมที่ต้องการเริ่มต้นใช้งานฟรีโดยไม่มีค่าธรรมเนียมติดตั้ง',
      'โรงแรม SMB และขนาดกลางที่ราคา Mews เกินงบ',
      'เครือโรงแรมหลายสาขาที่ต้องการจัดการส่วนกลางพร้อมปฏิบัติตามกฎหมายท้องถิ่น',
    ],
  },
  faqItems: [
    { question: 'HotelStack.io เปรียบเทียบกับ Mews อย่างไรในด้านคุณภาพ UI?', answer: 'ทั้งสองแพลตฟอร์มมีอินเทอร์เฟซทันสมัยและใช้งานง่าย HotelStack.io มีธีมหรูหราสีเข้มออกแบบเฉพาะสำหรับอุตสาหกรรมการบริการ พร้อม 36 โมดูลเข้าถึงได้จากแดชบอร์ดเดียว Mews มีดีไซน์มินิมอลสะอาดตาที่เน้นเวิร์กโฟลว์ยุโรป' },
    { question: 'Mews รวมความสามารถอาหารและเครื่องดื่มและ POS หรือไม่?', answer: 'Mews ต้องใช้การเชื่อมต่อบุคคลที่สามสำหรับอาหารและเครื่องดื่มและ POS HotelStack.io รวมเทอร์มินัล POS สมบูรณ์ โมดูลบริการห้องพัก ระบบแสดงผลครัว และจัดการร้านอาหารเป็นฟีเจอร์มาตรฐานในทุกแผน' },
    { question: 'ฉันจะได้ประสบการณ์ทันสมัยเหมือน Mews ในราคาถูกกว่าได้หรือไม่?', answer: 'ได้ HotelStack.io มอบประสบการณ์คลาวด์เนทีฟทันสมัยพร้อมซิงค์แบบเรียลไทม์ UI สวยงาม และ 36 โมดูลในราคา $49/เดือน เทียบกับ Mews ที่ $200+/เดือน นอกจากนี้การเริ่มต้นใช้งานและย้ายข้อมูลฟรี' },
    { question: 'HotelStack.io มีการเชื่อมต่อ API เหมือน Mews หรือไม่?', answer: 'ใช่ HotelStack.io มีตลาดการเชื่อมต่อพร้อม API สำหรับช่องทางชำระเงิน OTA ซอฟต์แวร์บัญชี และบริการบุคคลที่สาม สถาปัตยกรรม API-first ของเรารองรับการเชื่อมต่อแบบกำหนดเองสำหรับความต้องการองค์กร' },
  ],
};

export const COMPARISON_TH: Record<string, ComparisonConfig> = {
  'hotelstack-vs-hotelogix': HOTELOGIX_TH,
  'hotelstack-vs-cloudbeds': CLOUDBEDS_TH,
  'hotelstack-vs-mews': MEWS_TH,
};
